import { SHOW_MAIN_ERROR } from "./types";

export const showMainErrorPop = (err, align, callokf) => ({
	type: SHOW_MAIN_ERROR,
	payload: { msg: err, align:align, callokf: callokf }
});